
import { api } from '../../api'

import { localConfig } from '../../../Configs/localConfig'

export interface TypeCompatibilidadeInsumos {
  itens: [CompatibilidadeInsumos]
}

export interface CompatibilidadeInsumos {
  cod?: number
  cod_produto?: number
  cod_ativo?: number
  cod_tipo?: number
  cod_insumo?: number
  cod_ingrediente_ativo?: number
  cod_grupo_quimico?: number
  cod_cultura?: number
  cod_tecnologia?: number
  cod_adjuvante?: number
  cod_foliar?: number
  descricao?: string
  observacao?: string
  cod_conta?: number
  cultura_nome?: string
  ativo_nome?: string
  produto_nome?: string
  insumo_nome?: string
  ingrediente_ativo_nome?: string
  grupo_quimico_nome?: string
  tecnologia_nome?: string
}

interface TypeQuery {
  codConta?: number | string
  cod?: number
  codProduto?: number
  pagination?: number | -1
  embed?: string
}

const url = 'recomendacao/compatibilidade-produto'

export const getCompatibilidadeInsumos = async (params: TypeQuery) => {
  const { pagination = -1 } = params

  const { conta, acesso } = localConfig()

  api.defaults.headers.Acesso = acesso

  params = {
    pagination,
    codConta: conta,
    ...params,
  }

  const response = api.get(url, {
    params,
  })

  return response
}

export const postCompatibilidadeInsumos = async (data) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response = api.post(url, data, {
    params: {
      codConta: config.conta,
      embed: 'variacao',
    },
  })

  return response
}

export const putCompatibilidadeInsumos = async (cod, data, params?: TypeQuery) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response = api.put(`${url}/${cod}`, data, {
    params: {
      codConta: config.conta,
      ...params,
    },
  })

  return response
}

export const delCompatibilidadeInsumos = async (cod) => {
  const config = localConfig()

  api.defaults.headers.Acesso = config.acesso

  const response = api.delete(`${url}/${cod}`, {
    params: {
      codConta: config.conta,
    },
  })

  return response
}
